import {useState, useEffect} from "react";
import {ITechDirectionByIdFromServer} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTechDirectionById = (
  apiUrl: string,
  apiKey: string,
  directionId: string
) => {
  const [directionData, setDirectionData] =
    useState<ITechDirectionByIdFromServer | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!directionId) return;

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}/${directionId}`);
    url.searchParams.delete("populate");
    url.searchParams.set("populate[clusters][populate]", "image");

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data) => {
        setDirectionData(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey, directionId]);

  return {directionData, error};
};

export default useFetchDataTechDirectionById;
